<template>
    <div class="animated fadeIn apInvoiceDetail notification-templates bgV2" v-bind:class="{'run-loading': loadingItem}">
        <b-row>
            <b-col md="12">
                <gofix-tab
                        class="mt-3"
                        :data="tabData">
                    <template slot="gofixTab:right">
                        <gofix-button
                            v-if="!isMaster"
                            @click="saveItem"
                            :loading="loading"
                            label="SAVE"></gofix-button>
                    </template>
                    <template slot="gofixTab:basic-info">
                        <gofix-card title=" " class="px-4" fullContent>
                            <b-row>
                                <b-col md="5">
                                     <b-row>
                                        <b-col md="6">
                                            <gofix-text-field classLabel="width-99" class="mb-4" label="Module" oneline>{{ template.module }}</gofix-text-field>
                                        </b-col>
                                        <b-col md="6">
                                            <gofix-text-field class="mb-4" label="Medium" oneline>{{ template.medium }}</gofix-text-field>
                                        </b-col>
                                        <b-col md="12">
                                            <gofix-text-field classLabel="width-99" class="mb-4" label="Event Trigger" oneline>
                                                {{ template.event_trigger && template.event_trigger.name ? template.event_trigger.name : '--' }}
                                            </gofix-text-field>
                                        </b-col>
                                        <b-col md="12">
                                            <gofix-form-input
                                                label="Title"
                                                :disabled="isMaster"
                                                v-model="template.title"
                                                required />
                                        </b-col>
                                        <b-col md="12">
                                            <gofix-form-input
                                                label="Recipient Remark"
                                                :disabled="isMaster"
                                                v-model="template.recipient_remark"
                                                required />
                                        </b-col>
                                        <b-col md="12">
                                            <gofix-form-input-textarea
                                                class="mb-0"
                                                :rows="12"
                                                label="Remark"
                                                :disabled="isMaster"
                                                v-model="template.remark" />
                                        </b-col>
                                     </b-row>
                                </b-col>
                                <b-col md="7">
                                    <template v-if="template.module && template.medium == 'email'">
                                      <!-- <editor
                                          api-key="il3ub5ilogli9992n1eqrbnx9cond36i0lhx8n8i4xj9v1bo"
                                          :init="editorInit"
                                          v-model="template.content"
                                      /> -->
                                      <TinymceEditor :init="editorInit" v-model="template.content"/>
                                    </template>
                                    <template v-else>
                                        <gofix-form-input-textarea
                                            class="mb-0 gofixTextAreaInput-Content"
                                            :rows="10"
                                            label="Content"
                                            :disabled="isMaster"
                                            v-model="template.content" />
                                    </template>
                                </b-col>

                            </b-row>
                        </gofix-card>
                    </template>
                </gofix-tab>
            </b-col>
        </b-row>
    </div>
</template>
<script>
//   import Editor from '@tinymce/tinymce-vue';
    import TinymceEditor from '@/views/plugins/Editor.vue'
    export default {
        name: "contract-notification-detail",
        props: {
            isMaster: {
                type: Boolean,
                default: false
            }
        },
        components: {
        //   'editor': Editor
          TinymceEditor
        },
        data () {
            return {
              tabData:[
                  {
                      key: "basic-info",
                      title: "Basic Info",
                      active: true
                  }
              ],
              template: {
                  id: null,
                  module: null,
                  event_trigger_id: null,
                  title: null,
                  medium: null,
                  recipient_remark: null,
                  remark: null,
                  content: null
              },
              editorOption: {
                  theme: 'snow',
                  modules: {
                      toolbar: [
                          ['bold', 'italic', 'underline', 'strike'],
                          ['blockquote', 'code-block'],
                          [{ 'header': 1 }, { 'header': 2 }],
                          [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                          [{ 'indent': '-1'}, { 'indent': '+1' }],
                          [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
                          [{ 'color': [] }, { 'background': [] }],
                          [{ 'font': [] }],
                          [{ 'align': [] }],
                          ['clean'],
                          ['link'],
                      ]
                  },
                  placeholder: "Content"
              },
              loading: false,
              loadingItem: false,
              editorInit: {
                height: 500,
                menubar: false,
                content_style: "body {font-size: 11pt;}",
                plugins: [
                  'advlist autolink lists link image charmap print preview anchor',
                  'searchreplace visualblocks code fullscreen',
                  'insertdatetime media table paste code help wordcount',
                  'table emoticons template paste help',
                  'code',
                  'preview'
                ],
                toolbar:
                    'code | preview | formatselect | fontsizeselect | fontselect | bold italic backcolor | \
                    alignleft aligncenter alignright alignjustify | \
                    table  \
                    bullist numlist outdent indent | removeformat | help',
                fontsize_formats: '8pt 10pt 11pt 12pt 14pt 16pt 18pt 24pt 36pt 48pt',
                font_formats: "Arial=arial,helvetica,sans-serif; Arial Black=arial black,avant garde; Georgia=georgia,palatino; Helvetica=helvetica; Tahoma=tahoma,arial,helvetica,sans-serif; Terminal=terminal,monaco; Times New Roman=times new roman,times; Trebuchet MS=trebuchet ms,geneva; Verdana=verdana,geneva;"
              }
            }
        },
        created() {
            if (!this.$route.params.hasOwnProperty('config_notification_id') && isNaN(this.$route.params.config_notification_id)) {
                if(this.isMaster) return this.$router.push(`/settings/config-notification`);
                else return this.$router.push(`/v2/contract-client/${this.$route.params.id}/config-notification`);
            }
            this.getItem();
        },
        methods: {
            getItem() {
                this.loadingItem = true;
                this.$store.dispatch("NotificationTemplateController/getItem", this.$route.params.config_notification_id)
                    .then(response => {
                        this.template = JSON.parse(JSON.stringify(response))
                        this.loadingItem = false;
                    })
                    .catch(error => {
                        this.loadingItem = false;
                        let msg = "Can not load item";
                        if(error.response.data && error.response.data.error && error.response.data.error.message) {
                            msg = error.response.data.error.message;
                        }
                        this.$alertNotification(msg, "danger");
                    })
            },
            saveItem() {
                this.loading = true;
                this.$store.dispatch("NotificationTemplateController/saveItem", this.template)
                    .then(response => {
                        this.$alertNotification(this.$notificationV2('editing', 'notification_templates'));
                        this.loading = false;
                    })
                    .catch(err => {
                        this.loading = false;
                    })
            }
        }
    }
</script>
